import { X } from 'lucide-react';
import { CapabilityButton } from '../CapabilityButton';
import { permissionNames as P } from '../../auth/permissions.generated';
import type { ProductSummary } from '../../types/productComparer';

export const MAX_COMPARISON_SELECTION = 5;

export function ComparisonDock({ items, onRemove, onCompare }: {
    items: ProductSummary[];
    onRemove: (item: ProductSummary) => void;
    onCompare: () => void;
}) {
    if (!items.length) return null;
    return <div className="fixed bottom-6 left-1/2 z-40 w-full max-w-lg -translate-x-1/2 px-4" role="region" aria-label="Selected products for comparison">
        <div className="flex items-center justify-between gap-3 rounded-xl border bg-card p-4 shadow-xl">
            <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                    {items.map(item => <div key={item.entityId} className="group relative flex h-9 w-9 items-center justify-center rounded-full border-2 border-background bg-primary text-xs font-bold text-primary-foreground" title={item.internalName ?? undefined}>
                        {item.entityId.toString().slice(-3)}
                        <button type="button" aria-label={`Remove ${item.internalName ?? item.entityId} from comparison`} onClick={() => onRemove(item)} className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-destructive text-white">
                            <X className="h-3 w-3" />
                        </button>
                    </div>)}
                </div>
                <span className="text-sm" aria-live="polite"><strong>{items.length}</strong><span className="text-muted-foreground">/{MAX_COMPARISON_SELECTION}</span></span>
            </div>
            <CapabilityButton capability={P.ProductComparisonCompare} onClick={onCompare} disabled={items.length < 2}>Compare ({items.length})</CapabilityButton>
        </div>
    </div>;
}
